<script setup>
import Tags from '@/components/Tags.vue'
</script>
<template>
     <v-dialog
          v-model="ins_win"
          width="700px"
     >
          <v-toolbar
               height="50px"
               color="#E13532"
               dark
          >
                <v-toolbar-title>段落作成</v-toolbar-title>
                <v-spacer>
                </v-spacer>
                <v-tooltip bottom v-if="mode==1 && paragraph!=''">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="mode=2"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                            :disabled = "run_flg"
                        >
                            <v-icon
                            >
                                mdi-skip-forward
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>前回結果を表示</span>
                </v-tooltip>

                <v-tooltip bottom v-if="mode==2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="mode=1"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                                   :disabled = "run_flg"
                        >
                            <v-icon
                            >
                                mdi-skip-backward
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>条件指定に戻る</span>
                </v-tooltip>
                <v-tooltip bottom v-if="mode==2">
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="get_paragraph"
                            icon
                            class="mr-4"
                            v-on="on"
                            v-bind="attrs"
                                   :disabled = "run_flg"
                        >
                            <v-icon
                            >
                                mdi-head-sync
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>別案作成</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            @click="ins_win=false"
                            icon
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-icon
								small
                            >
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>閉じる</span>
                </v-tooltip>
          </v-toolbar>
          <v-card
               class="py-2"
               tile
               flat
               v-if="mode==1"
          >
               <v-card-text
                    class="py-2 px-4"
               >
            <v-row>
                 <v-col cols="1" class="px-0">
                         <span class="input-title">見出し</span>
                    </v-col>
                    <v-col>
                         <v-text-field
                           v-model="headline"
                           clearable
                           hide-details="auto"
                           dense
                           outlined
                         ></v-text-field>
                    </v-col>
            </v-row>
            <v-row>
                 <v-col cols="1" class="px-0">
                     <span class="input-title">概要</span>
                    </v-col>
                    <v-col>
                         <v-textarea
                                v-model="summary"
                                clearable
                                placeholder="内容の簡単な説明（100文字程度）"
                                hide-details="auto"
                                counter="100"
                                outlined
                         ></v-textarea>
                    </v-col>
            </v-row>
            <v-row
                    class="my-0"
               >
                 <v-col cols="1" class="py-2 px-0">
                     <span class="input-title">ヒント</span>
                    </v-col>
                    <v-col class="py-2">
                         <Tags v-model="tags"></Tags>
                         <p class="attention">入力後にリターンを押すと複数入力できます。</p>
                    </v-col>
            </v-row>
               </v-card-text>
               <v-card-actions>
                <v-spacer>
                </v-spacer>
                    <v-btn
                        @click="get_paragraph"
                        :disabled="mess_flg"
                        :loading="run_flg"
						color="#E13532"
						:dark="!mess_flg"
                    >
                         送信
                    </v-btn>
                <v-spacer>
                </v-spacer>
               </v-card-actions>
          </v-card>
        <v-card
            v-if="mode==2"
            flat
            tile
        >
               <v-card-text
                    class="pt-3"
               >
               <v-card
                    flat
                    outlined
               >
                    <v-card-text
                         style="background-color:#F7F7F8;"
                         class="py-2 px-2"
                         min-height="300px"
                    >
                         <div class="message_summary" v-html="paragraph_text"></div>
                    </v-card-text>
               </v-card>
               </v-card-text>
               <v-card-actions>
                    <v-spacer>
                    </v-spacer>
                         <v-btn
                              text
                              color="#459F7B"
                              outlined
                              class="ml-2"
                              @click="set_paragraph()"
                              :disabled = "run_flg"
                         >
                              採用
                         </v-btn>
                    <v-spacer>
                    </v-spacer>
               </v-card-actions>
          </v-card>
     </v-dialog>
</template>
<script>
export default{
     computed : {
          paragraph_text : function(){
               return this.paragraph.replaceAll("\n","<br>");
          },
     },
     watch : {
          tags : function(){
               if(this.tags == "")
               {
                    this.tags = null;
               }
          },
          headline : function(){
               if(this.headline != "" && this.summary != "")
               {
                    this.mess_flg = false;
               }
               else
               {
                    this.mess_flg = true;
               }
          },
          summary : function(){
               if(this.headline != "" && this.summary != "")
               {
                    this.mess_flg = false;
               }
               else
               {
                    this.mess_flg = true;
               }
          },

     },
     data: function(){
          return {
               ins_win : false,
               posX    : 0,
               tags    : null,
               headline : "",
               summary : "",
               mode    :1,
               run_flg : false,
               paragraph : "",
               mess_flg : true,
          };
     },
     methods : {
          open : function(){
               this.ins_win = true;
          },

        get_paragraph   : async function(){
            let url = "https://docs.qlipper.jp/gcal/paragraph";
            let query = {
                "headline" : this.headline,
                "summary"   : this.summary,
                "tags"     : this.tags,
            };
               this.run_flg = true;
               this.paragraph = "";
            let params = {method : "POST",headers : { "Content-type" : "application/json; charset=utf-8" }, body : JSON.stringify(query)};
            await fetch(url,params)
            .then(async (res) => {
                    this.mode=2;
                const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
				let loop_flg = true;
                while (loop_flg == true) {
                    const { done, value } = await reader.read();
                    if (done)
					{
						loop_flg=false;
						return;
					}
                    this.paragraph += value;
                }
            });
               this.run_flg = false;
          },
          set_paragraph : function(){
               this.$emit('paragraph',{"headline":this.headline,"paragraph":this.paragraph});
          }
     },
}
</script>
